<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>联系人列表</h4>
        </div>
        <div class="main-bd mg20">
            <el-row class="searchSection" >
                <el-form ref="form" :inline="true" :model="searcherModel" class="demo-form-inline">
                    <el-form-item label="联系人姓名">
                        <contact-select ref="ContactSelect" v-model="searcherModel.name" @change="ContactHandleChange" ></contact-select>
                    </el-form-item>
                    <el-form-item label="业务员姓名">
                        <UserSelect ref="UserSelect" v-model="searcherModel.salesman" @change="UserHandleChange"></UserSelect>
                    </el-form-item>
                    <el-form-item label="客户ID">
                        <el-input size="small" v-model="searcherModel.customer_id" placeholder="请输入ID"></el-input>
                    </el-form-item>
                    <span v-show="isCollapse" >
                        <el-form-item label="客户名称">
                            <CustomerSelect ref="CustomerSelect" v-model="searcherModel.customer_name" @change="CustomerHandleChange"></CustomerSelect>
                        </el-form-item>
                        <el-form-item label="联系人电话">
                            <el-input size="small" v-model="searcherModel.mobile" placeholder="请输入电话"></el-input>
                        </el-form-item>
                        <el-form-item label="联系人类型">
                            <el-select v-if="types" size="small" v-model="searcherModel.type" placeholder="请选择" >
                                <el-option v-for="(item, key) in types" :key="key" :label="item" :value="key">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </span>
                    <el-form-item>
                        <el-button type="primary" size="small" icon="el-icon-search" @click="submitSearch">搜索</el-button>
                        <el-button @click="resetForm()" size="small">重置</el-button>
                        <el-button v-if="Acs('/contacts/import-contacts')" type="success" size="small" icon="el-icon-upload2" @click="showImportDialog">导入联系人</el-button>
                        <a class="searchCollapse" @click="collapse()" >{{ searchTitle }}<i :class="{ 'el-icon-fa-angle-down': isDown, 'el-icon-fa-angle-up': isUp }"></i></a>
                    </el-form-item>
                </el-form>
            </el-row>

            <el-row>
                <el-col :span="12">

                    <el-card class="box-card">
                        <div slot="header" class="clearfix">
                            <span>联系人列表</span>
                        </div>

                        <el-table size="mini" :data="contacts" style="width: 100%" class="tabTopBorder" v-loading="loading" >
                            <el-table-column label="客户名称">
                                <template slot-scope="scope" >
                                    <el-button type="text"  @click="handleDetail(scope.row)" :title="scope.row.customer_name" >{{scope.row.customer_name}}</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="name" label="姓名"></el-table-column>
                            <el-table-column prop="mobile" width="200" label="电话">
                                <template slot-scope="scope">
                                    <span>{{scope.row.mobile}}</span>
                                    <span v-if="scope.row.phone_number && scope.row.mobile"><br/>{{scope.row.phone_number}}</span>
                                    <span v-else>{{scope.row.phone_number}}</span>
                                    <el-button v-if="scope.row.mobile != '' || scope.row.phone_number != ''" type="text" size="mini" icon="el-icon-unlock" @click="unlockMobile(scope.row)">解密</el-button>
                                </template>
                            </el-table-column>
                            <el-table-column prop="salesman" label="业务员"></el-table-column>
                            <el-table-column prop="created_at" label="录入时间" width="200"></el-table-column>
                        </el-table>
                        <el-row v-if="linkPage">
                            <pagination :linkPage="linkPage"></pagination>
                        </el-row>

                    </el-card>

                </el-col>
                <el-col :span="12">

                    <el-card class="box-card" v-if="members.length > 0">
                        <div slot="header" class="clearfix">
                            <span>账号列表</span>
                        </div>

                        <el-table size="mini" :data="members" style="width: 100%" class="tabTopBorder" v-loading="loading" >
                            <el-table-column label="客户名称" prop="customer_name"></el-table-column>
                            <el-table-column prop="username" label="用户名"></el-table-column>
                            <el-table-column prop="real_name" label="真实姓名"></el-table-column>
                            <el-table-column prop="mobile" label="实名/绑定手机"></el-table-column>
                            <el-table-column prop="seller" label="业务员"></el-table-column>
                        </el-table>
                    </el-card>

                </el-col>
            </el-row>

        </div>

        <!--新增联系人与编辑联系人的对话框-->
        <ContactForm v-if="showForm"
            :customerId = "customerId"
            :contactId = "contactId"
            :customerName = "customerName"
            :contact="contactObj"
            :isShowCustomerName = "false"
            :isUpdateCustomerName = "true"
            @changeShow = "changeShow"
            @changeCreate = "changeCreate"
            @changeUpdate = "changeUpdate"
        ></ContactForm>

        <!-- 导入联系人对话框 -->
        <el-dialog
            title="导入联系人"
            :visible.sync="importDialogVisible"
            width="500px"
            :close-on-click-modal="false">

            <el-form ref="importForm" label-width="0px">
                <el-form-item>
                    <el-input
                        v-model="importFileName"
                        placeholder="请选择文件"
                        disabled
                        style="width: 60%;">
                    </el-input>
                    <el-button
                        type="primary"
                        size="small"
                        @click="selectFile"
                        style="margin-left: 10px;">
                        选择文件 .xlsx
                    </el-button>
                    <input
                        type="file"
                        ref="fileInput"
                        @change="handleFileChange"
                        accept=".xlsx,.xls"
                        style="display: none;">
                </el-form-item>

                <el-form-item>
                    <div style="color: #409EFF; cursor: pointer;" @click="downloadTemplate">
                        <i class="el-icon-download"></i> 联系人模板下载.xlsx
                    </div>
                </el-form-item>

                <el-form-item>
                    <div style="color: #E6A23C;">
                        <i class="el-icon-warning"></i> 提示：一次最多导入2000个联系人
                    </div>
                </el-form-item>
            </el-form>

            <span slot="footer" class="dialog-footer">
                <el-button @click="closeImportDialog">取 消</el-button>
                <el-button type="primary" @click="handleImportSubmit" :loading="uploading">确 定</el-button>
            </span>
        </el-dialog>

    </div>

</template>


<script>
import Pagination from "~/widgets/Pagination.vue";
import UserSelect from "~/widgets/UserSelect.vue";
import ContactSelect from "~/widgets/ContactSelect.vue";
import CustomerSelect from "~/widgets/CustomerSelect.vue";
import ContactService from "~/services/contact";
import { STATUS_ON, STATUS_OFF } from "~/services/product";
import Params from "~/config/params";
import ContactForm from "~/views/contact/form.vue";
import CustomerAccountService from "~/services/CustomerAccounts";
import Function from "~/common/functions";

export default {
    components: {
        Pagination,
        UserSelect,
        CustomerSelect,
        ContactSelect,
        Params,
        ContactForm
    },

    data() {
        return {
            types: {},
            statuses: {},
            jobs: {},
            searcherModel: {
                name: "",
                salesman: "",
                mobile: "",
                customer_id: '',
                customer_name: "",
                type: ""
            },
            contacts: [],
            loading: true,
            // 分页信息
            linkPage: null,

            showForm: false,//是否展示Dialog对话框
            contactId: "",
            customerId: "",

            isCollapse: true,
            searchTitle: '展开',
            isDown: true,
            isUp: false,
            customerName: '',
            contactObj: null,
            members: [],

            // 导入相关
            importDialogVisible: false,
            importFileName: '',
            importFile: null,
            uploading: false
        };
    },
    // 监听路由参数更新执行分页请求
    beforeRouteUpdate: function (to, from, next) {
        let params = this.searcherModel;
            params['page'] = to.query["page"];
            params['perPage'] = to.query["perPage"];
			this.initListData(params);
    },

    created: function() {
        this.initListData();
        this.types = ContactService.getTypes();
        this.statuses = ContactService.getStatuses();
        this.jobs = ContactService.getJobs();
    },



    methods: {
        // 列表页点击客户名称跳转至详情页
        handleDetail(customer) {
            let routeData = this.$router.resolve({
                path: "/customers/view",
                query: { id: customer.customer_id },
            });
            window.open(routeData.href, '_blank');
        },

        // 客户列表展示
        initListData(params = {}) {

            // loading 动画
            this.loading = true;
            //所有联系人列表
            ContactService.getList(params).then(res => {
                this.contacts = res.data;
                if (res._meta) {
                    this.linkPage = res._meta;
                }
                this.loading = false;
            });

        },

        // 筛选查询
        submitSearch() {
            // loading 动画
            this.loading = true;
            let params = {
                name: this.searcherModel.name,
                salesman: this.searcherModel.salesman,
                mobile: this.searcherModel.mobile,
                customer_id: this.searcherModel.customer_id,
                customer_name: this.searcherModel.customer_name,
                type: this.searcherModel.type
            };
	        this.initListData(params);
            this.getMembers(params.mobile);
        },

        //重置筛选表单按按钮
        resetForm() {
            this.searcherModel = _.clone(_.extend(this.searcherModel, {
                name: '',
                salesman: '',
                mobile: '',
                customer_id: '',
                customer_name: '',
                type: ''
            }));
	        this.$refs["CustomerSelect"].reset();
            this.$refs["UserSelect"].reset();
            this.$refs["ContactSelect"].reset();
            this.$refs["form"].resetFields();
            this.initListData();
        },

        //新增联系人,展示Dialog对话框
        createContact() {
            this.showForm = true;
            this.contactId = '';
            this.customerId = '';
            this.customerName = ''
        },

        //修改联系人,展示Dialog对话框
        updateContact(contact) {
            this.showForm = true;
            this.customerName = contact.customer_name;
            this.contactId = contact.id;
            this.customerId = contact.customer_id;
            this.contactObj = contact;
        },

        //form dialog 的回调 start

        //关闭dialog窗口更新showForm值
        changeShow(isShow) {
            this.showForm = isShow;
        },

        //新增后列表中增加展示新数据
        changeCreate(contact) {
            this.initListData();
        },

        //编辑后列表数据立即更新
        changeUpdate(obj) {
            this.initListData();
        },
        //form dialog 的回调 end

        //删除联系人
        handleDelete(id) {
            this.$confirm("此操作是删除操作, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true
            }).then(() => {
                ContactService.delete(id).then(res => {
                    this.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    this.initListData();
                });
            }).catch(() => {});
        },

        //业务员姓名远程搜索组件赋值
        UserHandleChange(object) {
            this.searcherModel.salesman = object.value;
        },

        //客户名称远程搜索组件赋值
        CustomerHandleChange(object) {
            this.searcherModel.customer_name = object.value;
        },

        //联系人远程搜索组件赋值
        ContactHandleChange(object) {
            this.searcherModel.name = object.value;
        },

        // 部分搜索项隐藏展示切换
        collapse() {
            this.isCollapse = !this.isCollapse;
            if(this.isCollapse) {
                this.searchTitle = "收起";
                this.isUp = true;
                this.isDown = false;
            } else {
                this.searchTitle = "展开";
                this.isUp = false;
                this.isDown = true;
            }
        },

        unlockMobile(contact) {
            ContactService.decodeMobile({id: contact.id, type: 2}).then(res => {
                if (res.code == 0 && res.data) {
                    this.$message.success("解密成功！");
                    contact.mobile = res.data.mobile;
                    contact.phone_number = res.data.phone_number;
                }
            })
        },

        getMembers() {
            CustomerAccountService.getMemberList({mobile: this.searcherModel.mobile}).then(res => {
                if (res.code == 0 && res.data) {
                    this.members = res.data;
                }
            })
        },

        // ========== 导入联系人相关方法 ==========

        // 显示导入对话框
        showImportDialog() {
            this.importDialogVisible = true;
        },

        // 关闭导入对话框
        closeImportDialog() {
            this.importFileName = '';
            this.importFile = null;
            this.uploading = false;
            if (this.$refs.fileInput) {
                this.$refs.fileInput.value = '';
            }
            this.importDialogVisible = false;
        },

        // 选择文件
        selectFile() {
            this.$refs.fileInput.click();
        },

        // 文件改变
        handleFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                // 验证文件类型
                const fileType = file.name.split('.').pop().toLowerCase();
                if (fileType !== 'xlsx' && fileType !== 'xls') {
                    this.$message.error('只支持 .xlsx 或 .xls 格式的文件');
                    // 清空文件输入
                    this.$refs.fileInput.value = '';
                    return;
                }

                // 验证文件大小（限制10MB）
                if (file.size > 10 * 1024 * 1024) {
                    this.$message.error('文件大小不能超过10MB');
                    // 清空文件输入
                    this.$refs.fileInput.value = '';
                    return;
                }

                this.importFileName = file.name;
                this.importFile = file;
            }
        },

        // 下载模板
        downloadTemplate() {
            try {
                // 使用 Function.exportFile 方法下载模板
                let url = '/api/contacts/contact-example-export'; // 根据实际后端接口调整
                let params = {}; // 如果需要参数可以添加
                Function.exportFile(url, params);

                // 提示用户下载中
                this.$message.success('正在下载模板...');
            } catch (error) {
                console.error('下载模板失败:', error);
                this.$message.error('模板下载失败，请稍后重试');
            }
        },

        // 提交导入
        handleImportSubmit() {
            if (!this.importFile) {
                this.$message.warning('请先选择要导入的文件');
                return;
            }

            this.uploading = true;

            // 创建FormData对象
            const formData = new FormData();
            formData.append('file', this.importFile);

            // 调用导入API
            ContactService.importContact(formData).then(res => {
                this.uploading = false;
                if (res.code === 0) {
                    this.$message.success(res.message || '导入成功');
                    this.closeImportDialog();
                    // 刷新列表
                    this.initListData();
                }
            }).catch(err => {
                this.uploading = false;
                // this.$message.error('导入失败：' + (err.message || '未知错误'));
            });
        }
    }
};
</script>

<style scoped>
.el-form-item {
    margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// src/views/contact/index.vue